/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The part of the MCP an OpenAPI change affects.
 */
export const OpenAPIv3EvaluationCategory = {
  Security: "security",
  Tools: "tools",
  Server: "server",
} as const;
/**
 * The part of the MCP an OpenAPI change affects.
 */
export type OpenAPIv3EvaluationCategory = ClosedEnum<
  typeof OpenAPIv3EvaluationCategory
>;

/** @internal */
export const OpenAPIv3EvaluationCategory$inboundSchema: z.ZodMiniEnum<
  typeof OpenAPIv3EvaluationCategory
> = z.enum(OpenAPIv3EvaluationCategory);
